import { useEffect, useState } from 'react';
import RESTDataCache from '../api/cacheData';

export default (dataPath, cacheKey, initialState) => {
  const [restData, setRestData] = useState(initialState);

  useEffect(() => {
    RESTDataCache(dataPath, cacheKey).then(response => {
      setRestData(response);
    });
  }, []);

  return restData;
};
